export default __webpack_public_path__ + "static/media/enable_next_image.37519eef.svg";